// src/pages/ValuesPage.jsx
// src/pages/ValuesPage.jsx
import React from 'react';
import StyledCoreValuesGrid from '../components/sections/StyledCoreValuesGrid';
import ValuesDetailSection from '../components/sections/ValuesDetailSection';

const ValuesPage = () => {
  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <div className="py-20 bg-primary text-white">
        <div className="container mx-auto px-4">
          <h1 className="text-4xl font-bold mb-4 text-center">Our Core Values</h1>
          <div className="w-24 h-1 bg-white mx-auto my-4"></div>
          <p className="text-xl text-center max-w-3xl mx-auto">
            The principles that guide our practice and define our approach to legal excellence
          </p>
        </div>
      </div>
      
      {/* Core Values Grid - styled to match Firm page */}
      <StyledCoreValuesGrid />
      
      {/* Values Detail Section - styled to match Firm page */}
      <ValuesDetailSection />
    </div>
  );
};

export default ValuesPage;